"use client"

import React from "react"

import ImageWithFallback from "@/components/storyblok/common/ImageWithFallback"

interface ImagePreviewGroupProps {
  imageUrls: (string | undefined)[]
  size?: number
}

const MAX_VISIBLE = 3
export default function ImagePreviewGroup({ imageUrls, size }: ImagePreviewGroupProps) {
  const visibleImages = imageUrls.slice(0, MAX_VISIBLE)
  const remainingCount = imageUrls.length - MAX_VISIBLE
  let previewSize = size ?? 8
  return (
    <div
      className="grid grid-cols-2 gap-0 overflow-hidden rounded-lg border bg-white p-0"
      style={{
        width: `${previewSize}rem`,
        height: `${previewSize}rem`,
      }}
    >
      {visibleImages.map((url, idx) => (
        <div
          key={idx}
          className="relative flex items-center justify-center"
          style={{
            width: `${previewSize / 2}rem`,
            height: `${previewSize / 2}rem`,
          }}
        >
          <ImageWithFallback
            src={url ?? ""}
            width={(previewSize * 16) / 3}
            height={(previewSize * 16) / 3}
            alt={`Preview ${idx}`}
          />
        </div>
      ))}
      {remainingCount > 0 && (
        <div
          className="ml-3 mt-3 flex items-center justify-center rounded-br-lg bg-gray-100 text-sm font-medium text-gray-700"
          style={{
            width: `${previewSize / 2 - 1}rem`,
            height: `${previewSize / 2 - 1}rem`,
          }}
        >
          +{remainingCount}
        </div>
      )}
    </div>
  )
}
